/* Tema: Claro / Oscuro / Sistema. El atributo data-theme lo fija antes del primer pintado el script de head.html;
   aquí: estado, controles (menú del header + segmentados del menú móvil y del footer), persistencia y OS en vivo. */
(function () {
  'use strict';
  var KEY = 'rosvelet-theme', root = document.documentElement;
  var S = (window.Rosvelet && window.Rosvelet.strings) || {};
  var MODES = [['light', S.themeLight || 'Claro'], ['dark', S.themeDark || 'Oscuro'], ['system', S.themeSystem || 'Sistema']];
  var ICON = {
    light: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>',
    dark: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>',
    system: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>'
  };
  var LABEL = { light: MODES[0][1], dark: MODES[1][1], system: MODES[2][1] };
  var LABEL_TXT = S.themeLabel || 'Tema: __MODE__', ITEM_TXT = S.themeItem || 'Tema __MODE__', GROUP = S.theme || 'Tema';
  var META = { light: '#F7F3EF', dark: '#0F0E0D' };
  var mq = window.matchMedia('(prefers-color-scheme: dark)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mode = 'system', animTimer = 0;

  function read() { try { var v = localStorage.getItem(KEY); return v === 'light' || v === 'dark' ? v : 'system'; } catch (e) { return 'system'; } }
  function write(v) { try { localStorage.setItem(KEY, v); } catch (e) { /* modo privado: solo esta sesión */ } }

  function paintMeta() {
    var dark = mode === 'dark' || (mode === 'system' && mq.matches);
    Array.prototype.forEach.call(document.querySelectorAll('meta[name="theme-color"]'), function (m) {
      m.setAttribute('content', mode === 'system' ? (m.getAttribute('media').indexOf('dark') > -1 ? META.dark : META.light) : META[dark ? 'dark' : 'light']);
    });
  }
  function animate() {
    if (reduce.matches) return;
    root.classList.add('theme-anim');
    clearTimeout(animTimer);
    animTimer = setTimeout(function () { root.classList.remove('theme-anim'); }, 280);
  }
  function apply(next, fade) {
    if (fade) animate();
    mode = next;
    if (mode === 'system') root.removeAttribute('data-theme'); else root.setAttribute('data-theme', mode);
    paintMeta(); paintControls();
  }
  function choose(next) { write(next); apply(next, true); }

  /* ---------- Controles ---------- */
  var btn, pop, items;
  function buildMenu(host) {
    host.innerHTML = '<button class="icon-btn theme-btn" type="button" aria-haspopup="menu" aria-expanded="false" aria-controls="theme-pop">' +
      ICON.light.replace('<svg', '<svg class="i-light"') + ICON.dark.replace('<svg', '<svg class="i-dark"') + ICON.system.replace('<svg', '<svg class="i-system"') + '</button>' +
      '<div class="theme-pop" id="theme-pop" role="menu" aria-label="' + GROUP + '" hidden>' + MODES.map(function (m) {
        return '<button type="button" role="menuitemradio" aria-checked="false" data-mode="' + m[0] + '" tabindex="-1">' + ICON[m[0]] + m[1] + '</button>';
      }).join('') + '</div>';
    btn = host.querySelector('.theme-btn'); pop = host.querySelector('.theme-pop');
    items = Array.prototype.slice.call(pop.children);
    btn.addEventListener('click', function () { if (pop.hidden) openMenu(); else closeMenu(true); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); openMenu(e.key === 'ArrowUp'); }
    });
    pop.addEventListener('click', function (e) {
      var it = e.target.closest('[data-mode]');
      if (it) { choose(it.dataset.mode); closeMenu(true); }
    });
    pop.addEventListener('keydown', function (e) {
      var i = items.indexOf(document.activeElement);
      if (e.key === 'Escape') { e.preventDefault(); closeMenu(true); }
      else if (e.key === 'Tab') closeMenu(false);
      else if (e.key === 'ArrowDown') { e.preventDefault(); items[(i + 1) % items.length].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); items[(i + items.length - 1) % items.length].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); items[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); items[items.length - 1].focus(); }
    });
    document.addEventListener('pointerdown', function (e) { if (!pop.hidden && !host.contains(e.target)) closeMenu(false); });
  }
  function openMenu(last) {
    pop.hidden = false; btn.setAttribute('aria-expanded', 'true');
    var cur = items.filter(function (b) { return b.dataset.mode === mode; })[0];
    (last ? items[items.length - 1] : cur || items[0]).focus();
  }
  function closeMenu(refocus) {
    pop.hidden = true; btn.setAttribute('aria-expanded', 'false');
    if (refocus) btn.focus();
  }
  function buildSeg(host) {
    var compact = host.classList.contains('theme-seg--sm');
    host.setAttribute('role', 'group'); host.setAttribute('aria-label', GROUP);
    host.innerHTML = MODES.map(function (m) {
      return '<button type="button" data-mode="' + m[0] + '" aria-pressed="false"' + (compact ? ' aria-label="' + ITEM_TXT.replace('__MODE__', m[1]) + '" title="' + m[1] + '"' : '') + '>' + ICON[m[0]] + (compact ? '' : m[1]) + '</button>';
    }).join('');
    host.addEventListener('click', function (e) { var b = e.target.closest('[data-mode]'); if (b) choose(b.dataset.mode); });
  }
  function paintControls() {
    if (btn) {
      btn.dataset.mode = mode;
      btn.setAttribute('aria-label', LABEL_TXT.replace('__MODE__', LABEL[mode]));
      items.forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.mode === mode)); });
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-theme-seg] [data-mode]'), function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.mode === mode));
    });
  }

  var host = document.querySelector('[data-theme-menu]');
  if (host) buildMenu(host);
  Array.prototype.forEach.call(document.querySelectorAll('[data-theme-seg]'), buildSeg);
  apply(read(), false);
  /* Con "Sistema", el OS manda en vivo: el CSS ya sigue al media query; aquí solo meta theme-color. */
  var onOS = function () { if (mode === 'system') { animate(); paintMeta(); } };
  if (mq.addEventListener) mq.addEventListener('change', onOS); else if (mq.addListener) mq.addListener(onOS);
  window.addEventListener('storage', function (e) { if (e.key === KEY) apply(read(), true); });
})();
